<template>
  <div class="logger">
    <div class="header">操作日志</div>
    <no-data v-if="!totalLog"></no-data>
    <template v-else>
      <ul class="infinite-list">
        <li v-for="(i, index) in log" :key="index" class="infinite-list-item">
          <div class="list-item">
            <div class="list-item-line">
              <span class="label">创建人：</span>
              <span class="name">
                {{ i.creater_name }}
              </span>
            </div>
            <div class="list-item-line">
              <span class="label">操作记录：</span>
              <span class="name">{{ i.content }}</span>
            </div>
            <div class="list-item-line">
              <span class="label">操作时间：</span>
              <span class="name">{{ i.createtime | formatDate }}</span>
            </div>
          </div>
        </li>
      </ul>
      <pagination
        :total="totalLog"
        :page.sync="listQueryLog.page"
        :limit.sync="listQueryLog.limit"
        :page-sizes="[10,20,50,100]"
        @pagination="getLog"
      />
    </template>
  </div>
</template>
<script>
import Pagination from "@/components/Pagination";
import { actionLogList } from "@/api/common";
export default {
  name: "logger",
  components: {
    Pagination,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    types: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      log: [],
      totalLog: 0,
      listQueryLog: {
        page: 1,
        limit: 20,
      },
    };
  },
  mounted() {
    this.getLog();
  },
  methods: {
    async getLog() {
      const res = await actionLogList({
        account_id: this.$store.state.user.token.account_id,
        userid: this.data.owner,
        types: this.types,
        types_id: this.data.id,
        page: this.listQueryLog.page,
        number_page:this.listQueryLog.limit,
      });
      if (res.code == 1) {
        this.totalLog = res.count;
        this.log = res.data;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.header {
  
  display: flex;
  margin-top: 0;
  height: 50px;
  padding: 10px 22px;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: #eeeeee;
  display: none;
}

.logger{
  margin: 0 20px;
}

</style>